import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";

function App() {
  const [resetKey, setResetKey] = useState(0);

  const handleLogoClick = () => {
    // Increment key to force Hero to reset
    setResetKey((prev) => prev + 1);
  };

  return (
    <>
      <Navbar onLogoClick={handleLogoClick} />
      <Hero key={resetKey} />
    </>
  );
}

export default App;
